export default {
  pubKey: process.env.VUE_APP_STRIPE_PUB_KEY || ''
}
